export default "__VITE_ASSET__a4584d15__"